import React from "react";
import PropTypes from "prop-types";
import ReusableBowlToggle from "./ReusableBowlToggle";
import i18n from "~/assets/js/Helpers/i18n";
import { BOWLS_TYPES } from "./BowlsTypes";
import { Info, CreditCard, RefreshCw, AlertTriangle } from "react-feather";
import { useStocksForProducts } from "~/assets/js/Api/ingredientsApi.js";
import { useCartContext } from "~/assets/js/global/cartContext";
import Headline from "~/assets/js/components/Typography/Headline";
import OverlayLoader from "~/assets/js/components/Loaders/OverlayLoader";
import { hasReusableBowls } from "~/assets/js/Helpers/reusable-bowls-utils";

const ReusableBowlBox = ({ bowlType, onToggle }) => {
    const { cart } = useCartContext();
    const { reusableBowlsId } = reactConfig;
    const { inStock, isLoading } = useStocksForProducts(
        [reusableBowlsId],
        cart?.store_id
    );

    const noReusableBowlsInCart = hasReusableBowls(cart?.items);

    const isReusableSelected =
        bowlType === BOWLS_TYPES.REUSABLE ? "active" : "";

    if (isLoading) {
        return (
            <div
                style={{
                    width: "545px",
                    height: "300px",
                    position: "relative",
                }}
            >
                <OverlayLoader />
            </div>
        );
    }

    return (
        <div className="reusable-bowls">
            <div className="reusable-bowls__header">
                <div className="reusable-bowls__header-left">
                    <span>{i18n.t("cart.reusableBowls.title")}</span>
                    <p>{i18n.t("cart.reusableBowls.subtitle")}</p>
                </div>
                <div className="reusable-bowls__header-right">
                    <ReusableBowlToggle
                        bowlType={
                            !noReusableBowlsInCart
                                ? BOWLS_TYPES.CLASSIC
                                : bowlType
                        }
                        onToggle={onToggle}
                        disabled={!inStock}
                    />
                </div>
            </div>

            <div
                className={`reusable-bowls__content ${
                    !noReusableBowlsInCart ? "" : isReusableSelected
                }`}>
                <div className="reusable-bowls__content-upper">
                    <div className="icon">
                        <Info size={17} />
                    </div>

                    <p className="text">{i18n.t("cart.reusableBowls.price")}</p>
                </div>
                <hr className="line" />
                <div className="reusable-bowls__content-bottom">
                    <div className="content-row">
                        <CreditCard width={18} height={14} />

                        <p>{i18n.t("cart.reusableBowls.paymentMethod")}</p>
                    </div>
                    <div className="content-row">
                        <RefreshCw width={18} height={15} />

                        <p>{i18n.t("cart.reusableBowls.return")}</p>
                    </div>
                    <div className="content-link">
                        <a href="https://pottsalat.de/mehrweg ">
                            {i18n.t("cart.reusableBowls.link")}
                        </a>
                    </div>
                </div>
            </div>
            {!inStock && (
                <div className="reusable-bowls__not-available">
                    <div className="alert">
                        <AlertTriangle size={20} color={"#FFB340"} />
                    </div>

                    <div className="text">
                        {i18n.t("cart.reusableBowls.notAvailable")}
                    </div>
                </div>
            )}
        </div>
    );
};

ReusableBowlBox.propTypes = {
    bowlType: PropTypes.string.isRequired,
    onToggle: PropTypes.func.isRequired,
};
export default ReusableBowlBox;
